<template>
    <div class="DM_riskControlInfo">
        <!-- 伪激活详情 -->
        <el-dialog
            title="详情"
            :visible="detail.isShow"
            @close="handleClose"
            :close-on-click-modal="false"
        >
            <el-card class="box-card" shadow="hover">
                <el-row class="rowTitle">
                    <el-col :sm="12" :md="12" :lg="12">
                        <span class="labels">终端类型：</span>
                        <span>{{detail.info.brand_name}}</span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="12">
                        <span class="labels">终端SN：</span>
                        <span>{{detail.info.terminal_sn}}</span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="12">
                        <span class="labels">风控描述：</span>
                        <span>激活{{detail.info.days}}天刷满{{detail.info.target_money}}</span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="12">
                        <span class="labels">交易统计：</span>
                        <span>{{detail.info.transaction_money}}</span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="12">
                        <span class="labels">归属用户名称：</span>
                        <span>{{detail.info.real_name}}</span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="12">
                        <span class="labels">归属用户账号：</span>
                        <span>{{detail.info.phone}}</span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="12">
                        <span class="labels">扣款金额：</span>
                        <span>{{detail.info.deduction_money}}</span>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="12">
                        <span class="labels">扣款时间：</span>
                        <span>{{detail.info.deduction_time}}</span>
                    </el-col>
                </el-row>
                <el-table
                    :data="infoTable"
                    size="mini"
                    height="200"
                    border
                    style="width: 100%;margin-top:20px"
                    v-loading="loading"
                >
                    <!-- 序号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                    <!-- 代理名称 -->
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="name"
                        label="代理名称"
                        min-width="150"
                    ></el-table-column>
                    <!-- 政策 -->
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="dec_money"
                        label="已扣款金额"
                        min-width="100"
                    ></el-table-column>
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="status"
                        label="扣款状态"
                        min-width="100"
                    ></el-table-column>
                    <!-- 奖励分润 -->
                    <el-table-column
                        header-align="center"
                        align="center"
                        prop="dec_time"
                        label="扣款时间"
                        min-width="150"
                    ></el-table-column>
                </el-table>
            </el-card>
        </el-dialog>
    </div>
</template>
 
<script>
export default {
    name: "DM_riskControlInfo",
    props: {
        detail: {
            type: Object
        }
    },
    data() {
        return {
            infoTable: [], //表格
            viewData: {},
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            loading: true,
            level:sessionStorage.getItem('level') || 0,
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        handleClose() {
            this.$emit('infoClose')
        },
        getData() { //初始化
            this.$api.post("brand_risk_control/get_brand_risk_control_trigger_detail", { id: this.detail.info.id }, res => {
                if (res.code == 0) {
                    this.infoTable = res.data;
                    if (this.level != 0) {
                        let data = [];
                        res.data.map(function (v) {
                            if (v.level != '一级') {
                                data.push(v)
                            }
                        })
                        this.infoTable = data;
                    } else {
                        this.infoTable = res.data;
                    }
                    //渲染结束后取消加载
                    this.loading = false;
                } else {
                    this.$message.error(res.msg);
                    //渲染结束后取消加载
                    this.loading = false;
                }
            })
        }
    }
};
</script>

<style lang="scss" scope>
.DM_riskControlInfo {
    .purseTitle {
        font-size: 12px;
        margin: 10px 0;
        color: #909399;
        :nth-child(1) {
            font-weight: 700;
            color: #7f7f7f;
            padding-left: 10px;
            border-left: 4px solid #909399;
        }
    }
    .rowTitle {
        color: #909399;
        font-size: 12px;
        .el-col {
            margin: 5px 0;
        }
        .labels {
            font-weight: 700;
        }
    }
}
</style>
